import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'dhats-drawer',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './drawer.component.html',
  styleUrl: './drawer.component.scss',
})
export class DrawerComponent {
  @Input() title = '';
  @Input() isOpen = false;
  @Input() maxWidth = 'max-w-4xl';
  @Output() close = new EventEmitter<void>();

  onClose() {
    this.close.emit();
  }
}
